export const initialParnersState = {
  parners: []
};

export interface IParnersState {
  parners: any[]
}
